import React, { useState } from "react";
import api from "../../Axios/api";

import {
  Avatar,
  Button,
  TextField,
  Link,
  Paper,
  Grid,
  Typography,
  InputLabel,
} from "@material-ui/core";
import { LockOutlined } from "@material-ui/icons/";
import { withRouter, Redirect } from "react-router-dom";

import { useUserContext, loginUser } from "../../context/UserContext";
import useStyles from "./styles";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";

const Login = () => {
  const classes = useStyles();
  // context
  const { dispatch, store } = useUserContext();
  // console.log("store", store);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
    errorMessage: "",
  });

  const validateEmail = (email) => {
    const regEx =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const res = regEx.test(email);

    if (!res === true) {
      return "Wrong Email";
    }
    return "";
  };

  const handleChange = (input) => (e) => {
    var error = "";
    if (input === "email") {
      error = validateEmail(e.target.value);
    }
    setLoginData({
      ...loginData,
      [input]: e.target.value,
      errorMessage: error,
    });
  };

  const handleLoginVendor = (e) => {
    e.preventDefault();
    //scroll to the top of page
    window.scrollTo(0, 0)

    api
      .post("/buyer/login", {
        ...loginData,
      })
      .then(function (res) {
        setTimeout(() => setIsLoggedIn(true), [1000]);
        return loginUser(dispatch, res.data.data.buyer, res.data.data.token);
      })
      .catch((error) =>
        setLoginData({
          ...loginData,
          errorMessage:
            "ERROR: " + JSON.stringify(error.response.data.error.message),
        })
      );
  };

  return (
    <React.Fragment>
      {isLoggedIn ? <Redirect to="/" /> : ""}

      {/* Header here */}
      <Header />

      <Grid container className={classes.root}>
        <Grid
          className={classes.mainGrid}
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
        >
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlined />
            </Avatar>
            <Typography variant="h6">Welcome to DigiMart! Please login</Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Email Address"
                name="email"
                color="primary"
                autoFocus
                defaultValue={loginData.email}
                onChange={handleChange("email")}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                color="primary"
                defaultValue={loginData.password}
                onChange={handleChange("password")}
              />
              <InputLabel
                style={{
                  color: "red",
                  marginTop: 10,
                  marginBottom: 5,
                  textAlign: "center",
                }}
              >
                {loginData.errorMessage.toString()}
              </InputLabel>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={handleLoginVendor}
              >
                Sign In
              </Button>
              <Grid container justify="space-between">
                <Grid item>
                  <Link
                    href="/forget-password"
                    variant="body2"
                    color="primary"
                  >
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/buyer/register" variant="body2" color="primary">
                    Don't have an account?
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
        </Grid>
      </Grid>

      {/* Footer here */}
      <Footer />
    </React.Fragment>
  );
};

export default withRouter(Login);
